import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { UseUiStore } from './useUiStore.types'

export const useUiStore = create<UseUiStore>()(
  persist(
    (_) => ({
      isDesktopNavExpanded: true,
      tablePageSize: 10
    }),
    {
      name: 'ui-storage'
    }
  )
)

export const setDesktopNavExpanded = (isDesktopNavExpanded: boolean) =>
  useUiStore.setState({ isDesktopNavExpanded })
export const setTablePageSize = (tablePageSize: number) => useUiStore.setState({ tablePageSize })
